module.exports = ".app-detail {\n  margin-top: 100px;\n  margin-bottom: 100px;\n  color: black;\n}\n"